var Vendd = (function (Vendd) {
    'use strict';
    Vendd.FilterProduct = (function (FilterProduct) {

        FilterProduct.Messages = (function (Messages) {


            Messages.Add = function (id, path, extraAttributes, bundleItems) {
                var data = {
                    id: id,
                    path: path,
                    extraAttributes: extraAttributes, //example: extraAttributes: [{code:'test',value:'testValue'}]
                    bundleItems: bundleItems //example: bundleItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.FilterProduct.Messages.Add", data);
            };
            Messages.Add.className = "Vendd.FilterProduct.Messages.Add";

            Messages.Remove = function (id) {
                var data = {
                    id: id
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.FilterProduct.Messages.Remove", data);
            };
            Messages.Remove.className = "Vendd.FilterProduct.Messages.Remove";

            Messages.Clear = function () {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.FilterProduct.Messages.Clear");
            };
            Messages.Clear.className = "Vendd.FilterProduct.Messages.Clear";

            Messages.Changed = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.FilterProduct.Messages.Changed', model);
            };
            Messages.Changed.className = 'Vendd.FilterProduct.Messages.Changed';

            Messages.GetModel = function (configuration) {
                
                var data = {
                    configuration: configuration
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.FilterProduct.Messages.GetModel', configuration);
            };
            Messages.GetModel.className = 'Vendd.FilterProduct.Messages.GetModel';

            Messages.Failed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.FilterProduct.Messages.Failed', response);
            };
            Messages.Failed.className = 'Vendd.FilterProduct.Messages.Failed';

            Messages.GetNextFilter = function () {
                var data = {
                    serviceConfiguration: serviceConfiguration
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetNextFilter", data);
            };
            Messages.GetNextFilter.className = "Vendd.ScrollList.Messages.GetNextFilter";

            Messages.GetNextFilterSuccess = function (list, model) {
                var data = {
                    list: list,
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetNextFilterSuccess", data);
            };
            Messages.GetNextFilterSuccess.className = "Vendd.ScrollList.Messages.GetNextFilterSuccess";

            Messages.GetNextFilterFailure = function (list, response) {
                response.data = JSON.parse(response.data);
                var data = {
                    list: list,
                    response: response
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.ScrollList.Messages.GetNextFilterFailure", data);
            };

            return Messages;
        })(FilterProduct.Messages || {});

    return FilterProduct;

    })(Vendd.FilterProduct || {});

    return Vendd;

})(Vendd || {});